<template>
  <div>
    <div v-show="!this.initialLoading && !this.showForm">
      <div class="row">
        <div class="col-12 col-md-6 flexben-page-title">
          <h1>{{ $t("flexben.benefit.title") }}</h1>
          <p>{{ $t("flexben.benefit.description") }}</p>
        </div>
        <div class="col-12 col-md-6">
          <button v-if="!currentProviderCatalogCode" class="btn btn-themed px-4 float-right my-2" @click="openForm('create')">
            {{$t("flexben.benefit.add")}}
          </button>
        </div>
      </div>
      <div class="container-bg-white">
        <div class="row p-3">
          <div class="col-12 mb-3">
            <div class="row mt-1 align-items-center provider-tabs">
              <div class="col-12 col-md-3 col-xl-2 mt-1 mt-md-0"
                   v-for="provider in benefitProviders"
                   :key="provider.id">
                <div class="btn-request-type text-themed-dark d-flex align-items-center justify-content-center"
                     :class="{'btn-request-type-active': activeProviderId === provider.id}"
                     @click="changeProvider(provider.id)">
                  <div>
                    <div class="text-20 text-uppercase">{{ provider.label || provider.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-3 mb-2 mb-xl-0">
            <img src="@/assets/images/filter.svg"/>
            <span class="ml-3">{{$t("flexben.general.filter")}}</span>
          </div>
          <div v-if="isCoreProviderActive" class="col-12 col-xl-9">
            <div class="row">
              <div class="col-md-4 form-group">
                <label for="legislated_type" class="col-form-label pt-0">{{ $t("flexben.benefit.legislated_type") }}</label>
                <select class="form-control" v-model="params.legislated_type" id="legislated_type"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option v-for="type in filter_values.legislated_types" :key="type" :value="type">
                    {{$t("flexben.benefit.legislated_types." + type)}}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="sub_type" class="col-form-label pt-0">{{ $t("flexben.benefit.fields.sub_type") }}</label>
                <select class="form-control" v-model="params.sub_type" id="sub_type"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option v-for="type in filter_values.sub_types" :key="type" :value="type">
                    {{$t("flexben.benefit.sub_types." + type)}}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="select_status" class="col-form-label pt-0">{{ $t("flexben.general.status") }}</label>
                <select type="text" class="form-control" v-model="params.status" id="select_status"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option v-for="(status, index) in filter_values.statuses" :key="index" :value="status">
                    {{$t("flexben.general.status_type." + status.toLowerCase())}}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="fiscal_treatments" class="col-form-label pt-0">{{ $t("flexben.benefit.fiscal_treatment")
                  }}</label>
                <select type="text" class="form-control" v-model="params.fiscal_treatment" id="fiscal_treatments"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option v-for="(item, index) in filter_values.fiscal_treatments" :key="index" :value="item">
                    {{ $t("flexben.benefit.deductibility."+item) }}
                  </option>
                </select>
              </div>

              <div class="col-md-4 form-group">
                <label for="select_partner" class="col-form-label pt-0">{{ $t("flexben.benefit.fields.partner")
                  }}</label>
                <select class="form-control" v-model="params.partner" id="select_partner"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option :value="0">{{ $t('flexben.benefit.no_partner') }}</option>
                  <option v-for="(partner, index) in filter_values.partners" :key="index" :value="index">
                    {{ partner }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="select_location_availability" class="col-form-label pt-0">{{ $t("flexben.benefit.available_locations")
                  }}</label>
                <select class="form-control" v-model="params.location_availability" id="select_location_availability"
                        @change="filerValues()">
                  <option v-for="(location) in filter_values.location_availability" :key="location" :value="location">

                    {{$t("flexben.benefit.location_availability." + location)}}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="nav_tree_mapping_status" class="col-form-label pt-0">App category</label>
                <select class="form-control" v-model="params.nav_tree_mapping_status" id="nav_tree_mapping_status"
                        @change="filerValues()">
                  <option value="all">All</option>
                  <option value="mapped">Mapped</option>
                  <option value="unmapped">Unmapped</option>
                </select>
              </div>
            </div>
          </div>
          <div v-else-if="isProviderCatalogMode || isExternalExceptionProviderActive" class="col-12 col-xl-9">
            <div class="row">
              <div class="col-md-4 form-group">
                <label for="select_status" class="col-form-label pt-0">{{ $t("flexben.general.status") }}</label>
                <select type="text" class="form-control" v-model="params.status" id="select_status"
                        @change="filerValues()">
                  <option :value="null">-</option>
                  <option v-for="(status, index) in filter_values.statuses" :key="index" :value="status">
                    {{$t("flexben.general.status_type." + status.toLowerCase())}}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="exception_status" class="col-form-label pt-0">Exception status</label>
                <select class="form-control" v-model="params.exception_status" id="exception_status"
                        @change="changeExceptionStatus(params.exception_status)">
                  <option value="all">All</option>
                  <option value="in_exception">In exception</option>
                  <option value="not_in_exception">Not in exception</option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label for="external_nav_tree_mapping_status" class="col-form-label pt-0">App category</label>
                <select class="form-control" v-model="params.nav_tree_mapping_status" id="external_nav_tree_mapping_status"
                        @change="filerValues()">
                  <option value="all">All</option>
                  <option value="mapped">Mapped</option>
                  <option value="unmapped">Unmapped</option>
                </select>
              </div>
              <div v-if="isProviderCatalogMode" class="col-md-4 form-group">
                <label for="sync_status" class="col-form-label pt-0">Sync status</label>
                <select type="text" class="form-control" v-model="params.sync_status" id="sync_status"
                        @change="filerValues()">
                  <option v-for="status in providerCatalogStatusOptions" :key="status.value" :value="status.value">
                    {{ status.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div>
        </div>
        <div class="col-12 mt-2 d-flex justify-content-end">
            <button v-if="isProviderCatalogMode"
                    type="button"
                    class="btn btn-themed float-right px-4 mr-2"
                    :disabled="isProviderCatalogActionRunning"
                    @click="refreshProviderCache()">
              {{ refreshingProviderCache ? 'Refreshing...' : 'Refresh cache' }}
            </button>
            <button v-if="canShowRunProviderSyncCommand"
                    type="button"
                    class="btn btn-themed float-right px-4 mr-2"
                    :disabled="isProviderCatalogActionRunning || confirmingProviderSyncCommand"
                    @click="confirmRunProviderSyncCommand()">
              {{ runningProviderSyncCommand ? 'Running sync...' : 'Run sync command' }}
            </button>
            <a class="btn btn-themed float-right px-4"
                  :class="{'disabled':benefits.data.length == 0 || isDownloading}"
                 @click="exportBenefits()"
                 target="_blank"
                 download
                 >
                {{$t("flexben.benefit.btn.export")}}
              </a>
          <a class="btn btn-themed float-right px-4 ml-2"
             @click="exportDiscountVouchers()"
             target="_blank"
             download
          >
            {{$t("flexben.benefit.btn.export_discount")}}
          </a>
          </div>
        </div>
      </div>
      <div class="container-bg-white mt-3">
        <div class="row p-3">
          <div class="col-12 col-md-6">
            <h3 class="pl-0 mt-0">{{ $t("flexben.benefit.title") }}</h3>
          </div>
          <div class="col-12 col-md-6">
            <input type="text"
                   v-model="searchString"
                   v-on:keyup.enter="search()"
                   :placeholder="$t('flexben.general.search')"
                   class="formedituser search-input float-right"/>
          </div>
          <div v-if="isProviderCatalogMode" class="col-12 mb-2">
            <div v-if="providerCacheMissing" class="alert alert-warning mb-2">
              Provider cache is empty. Use Refresh cache.
            </div>
            <div class="d-flex flex-wrap align-items-center justify-content-between provider-cache-meta">
              <div>
                <span>Last cache refresh: {{ providerCacheCachedAt }}</span>
                <span class="ml-3">Total provider products: {{ providerCacheTotal }}</span>
              </div>
              <button v-if="selectedProviderProductIds.length > 0"
                      type="button"
                      class="btn btn-themed px-4 mt-2 mt-md-0"
                      :disabled="isProviderCatalogActionRunning"
                      @click="syncSelectedProviderProducts()">
                {{ providerSyncSubmitting ? 'Syncing...' : 'Sync selected' }}
                ({{ selectedProviderProductIds.length }})
              </button>
            </div>
          </div>
          <div v-if="!isProviderCatalogMode && selectedBenefitIds.length > 0" class="col-12 mb-2 d-flex justify-content-end">
            <button type="button"
                    v-if="selectedNotInExceptionBenefits.length > 0"
                    class="btn btn-themed px-4"
                    :disabled="exceptionSubmitting"
                    @click="addSelectedInException()">
              {{ selectedInExceptionBenefits.length > 0 ? 'Add selected not in exception' : 'Add selected in exception' }}
              ({{ selectedNotInExceptionBenefits.length }})
            </button>
            <button type="button"
                    v-if="selectedInExceptionBenefits.length > 0"
                    class="btn btn-themed px-4 ml-2"
                    :disabled="exceptionSubmitting"
                    @click="removeSelectedFromException()">
              {{ selectedNotInExceptionBenefits.length > 0 ? 'Remove selected in exception' : 'Remove selected from exception' }}
              ({{ selectedInExceptionBenefits.length }})
            </button>
          </div>
          <div class="col-12">
            <div class="table-responsive scaled-table hover-table">
              <table class="table table-striped">
                <thead>
                <tr>
                  <td @click="sortBy('id')" class="cursor-pointer">
                    #Id
                  </td>
                  <td v-if="showExceptionSelectionColumn"></td>
                  <td @click="sortBy('name')" class="cursor-pointer">
                    {{ $t("flexben.general.name") }}
                    <img src="@/assets/images/arrow-down-fill.svg"
                         :style="sortByField === 'name' && reverseSort ? 'transform: rotate(180deg)' : ''"/>
                  </td>
                  <td>{{ $t("flexben.benefit.legislated_type") }}</td>
                  <td  @click="sortBy('sub_type')" class="cursor-pointer">
                    {{ $t("flexben.benefit.fields.sub_type") }}
                    <img src="@/assets/images/arrow-down-fill.svg"
                         :style="sortByField === 'sub_type' && reverseSort ? 'transform: rotate(180deg)' : ''"/>
                  </td>
                  <td v-if="isCoreProviderActive" @click="sortBy('partner_id')" class="cursor-pointer">
                    {{ $t("flexben.benefit.fields.partner") }}
                    <img src="@/assets/images/arrow-down-fill.svg"
                         :style="sortByField === 'partner_id' && reverseSort ? 'transform: rotate(180deg)' : ''"/>
                  </td>
                  <td>App category</td>
                  <td>Brand</td>
                  <td @click="sortBy('status')" class="cursor-pointer">
                    {{ $t("flexben.general.status") }}
                    <img src="@/assets/images/arrow-down-fill.svg"
                         :style="sortByField === 'status' && reverseSort ? 'transform: rotate(180deg)' : ''"/>
                  </td>
                  <td>{{ $t("flexben.benefit.available_locations") }}</td>
                  <td></td>
                </tr>
                </thead>
                <tbody v-if="benefits.data.length > 0">
                <tr class="trhover parent" v-for="(item, index) in benefits.data" :key="getRowKey(item, index)">
                  <td>{{ getBenefitRowId(item) }}</td>
                  <td v-if="showExceptionSelectionColumn">
                    <input v-if="canShowSelectionCheckbox(item)"
                           type="checkbox"
                           class="form-check cursor-pointer"
                           :disabled="isProviderCatalogMode && (!canSelectProviderProduct(item) || isProviderCatalogActionRunning)"
                           :checked="isRowSelected(item)"
                           @change="toggleRowSelection(item)">
                  </td>
                  <td>
                    <img class="flx-table-image mr-2" :src="getBenefitImage(item)"/>
                    <span class="align-middle text-ellipsis-15">{{ getBenefitName(item) }}</span>
                  </td>
                  <td>{{ getLegislatedTypeLabel(item) }}
                  </td>
                  <td>{{ (item.sub_type) ? $t("flexben.benefit.sub_types." + item.sub_type) : '-'}}</td>
                  <td v-if="isCoreProviderActive">{{ (item.partner_id && item.partner) ? item.partner.name : '-'}}</td>
                  <td class="app-category-cell">
                    <div v-if="isMappedInNavTree(item) && getGroupedNavTreeMappings(item).length > 0"
                         class="app-category-tree"
                         :title="getNavTreeMappingLabel(item)">
                      <div v-for="group in getGroupedNavTreeMappings(item)"
                           :key="group.key"
                           class="app-category-group">
                        <div class="app-category-name">{{ group.category_name }}</div>
                        <ul v-if="group.subcategories.length > 0" class="app-subcategory-list">
                          <li v-for="subcategory in group.subcategories" :key="subcategory.key">
                            {{ subcategory.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <span v-else-if="isMappedInNavTree(item)"
                          class="app-category-label"
                          :title="getNavTreeMappingLabel(item)">
                      {{ getNavTreeMappingLabel(item) }}
                    </span>
                    <span v-else
                          class="sync-badge badge badge-secondary"
                          :title="getNavTreeMappingLabel(item)">
                      {{ getNavTreeMappingLabel(item) }}
                    </span>
                  </td>
                  <td>
                    {{ getBrandLabel(item) }}
                  </td>
                  <td>
                    <span :class="getStatusClass(item)" class="benefit-status m-0">{{ getStatusLabel(item) }}</span>
                  </td>
                  <td>
                    {{ getLocationAvailabilityLabel(item) }}
                  </td>
                  <td>
                    <button v-if="canOpenBenefitForm(item)"
                            class="btn action-button mr-1"
                            @click="openForm('update', index)">
                      {{$t("flexben.general.btn.see_more")}}
                    </button>
                    <button v-if="canSyncProviderProduct(item)"
                            class="btn action-button"
                            :disabled="isProviderCatalogActionRunning"
                            @click="syncProviderProduct(item)">
                      Sync
                    </button>
                    <button v-if="canAddInProviderException(item)"
                            class="btn action-button"
                            :disabled="exceptionSubmitting"
                            @click="toggleBenefitException(item)">
                      {{ item.is_in_exception ? 'Remove from exception' : 'Add in exception' }}
                    </button>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="trhover">
                  <td :colspan="tableColspan" class="text-center gri-cell">{{$t('flexben.general.no_results_found')}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 p-0">
            <listPagination
              :activePage="benefits.current_page"
              :currentPage="benefits.current_page"
              :totalItems="benefits.total"
              :startItem="benefits.from"
              :endItem="benefits.to"
              :itemsPerPage="benefits.perPage"
              @pageChanged="pageChanged"
              @changePerPage="changePerPage"></listPagination>
          </div>
        </div>
      </div>
    </div>

    <BenefitForm v-if="showForm" :formAction="formAction" :itemId="itemId"
                 @clearForm="clearForm"/>

    <content-loader :loader-visible="this.loading" :loader-error="loaderError"></content-loader>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben.js";
import moment from "moment";
import Cookies from "js-cookie";
import BenefitForm from "@/components/flexben/benefits/BenefitForm";
import utils from "@/plugins/utils";

export default {
  name: 'BenefitsIndex',
  components: {BenefitForm},
  data() {
    return {
      initialLoading: true,
      loading: true,
      loaderError: false,
      httpService: httpFlexbenService.benefitsService,
      globalVariables: httpFlexbenService.globalVariablesService.baseImagePreview,
      locale: this.$store.state.language,
      httpFlexbenService: httpFlexbenService.exports,
      isDownloading: false,
      // filtering
      filter_values: {
        legislated_types: [],
        fiscal_treatments: [],
        sub_types: [],
        statuses: ['INACTIVE', 'DRAFT', 'ACTIVE', 'DELETED'],
        partners: [],
        location_availability: [],
      },
      searchString: '',
      reverseSort: false,
      sortByField: null,
      params: {
        legislated_type: null,
        sub_type: null,
        fiscal_treatment: null,
        type: null,
        status: null,
        partner: null,
        page: 1,
        perPage: 20,
        sort_by: null,
        sort_direction: null,
        location_availability: 0,
        provider_id: null,
        exception_status: null,
        nav_tree_mapping_status: 'all',
        sync_status: 'all'
      },
      activeFilter: {
        filter_type: null,
        filter_status: null
      },
      benefits: {
        data: [],
        current_page: 1,
        from: 1,
        to: 1,
        perPage: 1,
        lastPage: 1,
        total: 1,
      },
      benefitProviders: [],
      activeProviderId: null,
      selectedBenefits: [],
      selectedProviderProducts: [],
      providerCatalogMeta: {
        cache_missing: false,
        cache: null,
        pagination: null,
      },
      providerCatalogStatusOptions: [
        {value: 'all', label: 'All'},
        {value: 'synced', label: 'Synced'},
        {value: 'not_synced', label: 'Not synced'},
        {value: 'excluded', label: 'Excluded'},
      ],
      exceptionSubmitting: false,
      providerSyncSubmitting: false,
      refreshingProviderCache: false,
      runningProviderSyncCommand: false,
      confirmingProviderSyncCommand: false,
      formAction: '',
      showForm: false,
      itemIndex: null,
      itemId: null
    }
  },
  created() {
    let permissions = this.flxUserLevel();
    if (permissions.hasAccess && permissions.userLevel === 'admin') {
      this._loadBenefitProviders();
    } else {
      window.location.href = '/company';
    }
  },
  beforeUpdate() {
    this.locale = this.$store.state.language;
  },
  computed: {
    activeProvider() {
      if (this.activeProviderId === null) {
        return null;
      }

      return this.benefitProviders.find(provider => provider.id === this.activeProviderId) || null;
    },
    selectedBenefitIds() {
      return this.selectedBenefits.map(item => item.id);
    },
    selectedInExceptionBenefits() {
      return this.selectedBenefits.filter(item => item.is_in_exception);
    },
    selectedNotInExceptionBenefits() {
      return this.selectedBenefits.filter(item => !item.is_in_exception);
    },
    selectedProviderProductIds() {
      return this.selectedProviderProducts.map(item => item.external_id).filter(Boolean);
    },
    isCoreProviderActive() {
      if (!this.activeProvider) {
        return false;
      }

      return this.normalizeProviderValue(this.activeProvider.name) === 'core'
        || this.normalizeProviderValue(this.activeProvider.label) === 'core'
        || this.normalizeProviderValue(this.activeProvider.code) === 'core';
    },
    showExceptionSelectionColumn() {
      return this.isProviderCatalogMode || this.isExternalExceptionProviderActive;
    },
    showExceptionFilter() {
      return !this.isProviderCatalogMode && this.isExternalExceptionProviderActive;
    },
    isExternalExceptionProviderActive() {
      return this.activeProvider ? this.isExceptionProvider(this.activeProvider) : false;
    },
    isProviderCatalogMode() {
      return this.activeProvider ? this.isProviderCatalogProvider(this.activeProvider) : false;
    },
    currentProviderCatalogCode() {
      if (!this.activeProvider) {
        return null;
      }

      const identifiers = [
        this.activeProvider.code,
        this.activeProvider.slug,
        this.activeProvider.name,
        this.activeProvider.label,
      ].map(this.normalizeProviderValue);

      if (identifiers.includes('briliap') || identifiers.includes('briliam')) {
        return 'briliap';
      }

      if (identifiers.includes('vd') || identifiers.includes('voucherdepot')) {
        return 'vd';
      }

      return null;
    },
    providerCacheMissing() {
      return Boolean(this.providerCatalogMeta && this.providerCatalogMeta.cache_missing);
    },
    providerCacheTotal() {
      const cache = this.providerCatalogMeta && this.providerCatalogMeta.cache;

      return cache && typeof cache.total !== 'undefined' ? cache.total : '-';
    },
    providerCacheCachedAt() {
      const cache = this.providerCatalogMeta && this.providerCatalogMeta.cache;

      return cache && cache.cached_at ? cache.cached_at : '-';
    },
    isProductionEnvironment() {
      const environment = (process.env.VUE_APP_ENV || process.env.NODE_ENV || '').toLowerCase();

      return ['production', 'prod'].includes(environment);
    },
    canShowRunProviderSyncCommand() {
      return this.isProviderCatalogMode && !this.isProductionEnvironment;
    },
    isProviderCatalogActionRunning() {
      return this.refreshingProviderCache || this.runningProviderSyncCommand || this.providerSyncSubmitting;
    },
    tableColspan() {
      let columns = 8;

      if (this.showExceptionSelectionColumn) {
        columns++;
      }

      if (this.isCoreProviderActive) {
        columns++;
      }

      return columns;
    }
  },
  methods: {
    _loadList() {
      if (!this.activeProviderId) {
        this.setEmptyBenefitsList();
        this.initialLoading = false;
        this.loading = false;
        return;
      }

      if (this.isProviderCatalogMode) {
        this._loadProviderProductsList();
        return;
      }

      this.loading = true;
      this.httpService
        .loadList(this.getListParams())
        .then((response) => {
          this.benefits.data = response.data.list.data;
          this.benefits.current_page = response.data.list.current_page;
          this.benefits.to = response.data.list.to;
          this.benefits.perPage = response.data.list.perPage;
          this.benefits.lastPage = response.data.list.lastPage;
          this.benefits.total = response.data.list.total;
          this.initialLoading = true;
          this.loading = false;
          if (this.initialLoading) {
            this.initialLoading = false;
            this.filter_values = {
              legislated_types: response.data.filters.legislated_types,
              fiscal_treatments: response.data.filters.fiscal_treatments,
              sub_types: response.data.filters.sub_types,
              statuses: response.data.filters.statuses,
              partners: response.data.filters.partners,
              location_availability: response.data.filters.location_availability,
            };
          }
        })
        .catch(() => {
          this.loading = false;
          this.loaderError = true;
        });
    },
    _loadProviderProductsList() {
      if (!this.currentProviderCatalogCode) {
        this.setEmptyBenefitsList();
        this.initialLoading = false;
        this.loading = false;
        return;
      }

      this.loading = true;
      this.httpService
        .getProviderProducts(this.getProviderProductsParams())
        .then((response) => {
          const responseData = response.data || {};
          const pagination = (responseData.meta && responseData.meta.pagination) || {};

          this.providerCatalogMeta = {
            cache_missing: Boolean(responseData.meta && responseData.meta.cache_missing),
            cache: (responseData.meta && responseData.meta.cache) || null,
            pagination: pagination,
          };
          this.benefits.data = Array.isArray(responseData.data) ? responseData.data : [];
          this.benefits.current_page = pagination.current_page || pagination.page || this.params.page || 1;
          this.benefits.from = pagination.from || (this.benefits.data.length > 0 ? 1 : 0);
          this.benefits.to = pagination.to || this.benefits.data.length;
          this.benefits.perPage = pagination.per_page || pagination.perPage || this.params.perPage;
          this.benefits.lastPage = pagination.last_page || pagination.lastPage || 1;
          this.benefits.total = pagination.total || this.benefits.data.length;
        })
        .catch(() => {
          this.loaderError = true;
        })
        .finally(() => {
          this.initialLoading = false;
          this.loading = false;
        });
    },
    getListParams() {
      let params = {...this.params};
      params.provider_id = this.activeProviderId;
      delete params.sync_status;

      if (!this.showExceptionFilter) {
        delete params.exception_status;
      } else if (!params.exception_status) {
        params.exception_status = 'all';
      }

      return params;
    },
    getProviderProductsParams() {
      const params = {
        provider: this.currentProviderCatalogCode,
        sync_status: this.params.sync_status || 'all',
        search: this.params.search || null,
        page: this.params.page || 1,
        per_page: this.params.perPage || 20,
      };

      if (this.params.status) {
        params.status = this.params.status;
      }

      if (this.params.exception_status) {
        params.exception_status = this.params.exception_status;
      }

      if (this.params.nav_tree_mapping_status) {
        params.nav_tree_mapping_status = this.params.nav_tree_mapping_status;
      }

      return params;
    },
    _loadBenefitProviders() {
      this.loading = true;
      this.httpService
        .getBenefitProviders()
        .then((response) => {
          this.benefitProviders = this.parseBenefitProviders(response);
          this.selectDefaultProvider();
        })
        .catch(() => {
          this.benefitProviders = [];
          console.warn('Benefit providers endpoint is not available yet.');
          this.setEmptyBenefitsList();
          this.initialLoading = false;
          this.loading = false;
        });
    },
    parseBenefitProviders(response) {
      if (Array.isArray(response)) {
        return response;
      }

      if (response && Array.isArray(response.data)) {
        return response.data;
      }

      if (response && response.data && Array.isArray(response.data.providers)) {
        return response.data.providers;
      }

      if (response && response.data && response.data.data && Array.isArray(response.data.data.providers)) {
        return response.data.data.providers;
      }

      return [];
    },
    selectDefaultProvider() {
      if (this.benefitProviders.length === 0) {
        this.setEmptyBenefitsList();
        this.initialLoading = false;
        this.loading = false;
        return;
      }

      const defaultProvider = this.benefitProviders.find(provider => {
        return this.normalizeProviderValue(provider.name) === 'core'
          || this.normalizeProviderValue(provider.label) === 'core';
      }) || this.benefitProviders[0];

      this.activeProviderId = defaultProvider.id;
      this.params.provider_id = defaultProvider.id;
      this.setProviderExceptionStatus();
      this.setProviderCatalogStatus();
      this.params.page = 1;
      this.clearSelectedRows();
      this._loadList();
    },
    setEmptyBenefitsList() {
      this.benefits = {
        data: [],
        current_page: 1,
        from: 0,
        to: 0,
        perPage: this.params.perPage,
        lastPage: 1,
        total: 0,
      };
    },
    filerValues() {
      this.params.page = 1;
      this.clearSelectedRows();
      this._loadList();
    },
    changeProvider(providerId) {
      if (this.activeProviderId === providerId) {
        return;
      }

      this.activeProviderId = providerId;
      this.params.provider_id = providerId;
      this.setProviderExceptionStatus();
      this.setProviderCatalogStatus();
      this.params.page = 1;
      this.clearSelectedRows();
      this._loadList();
    },
    setProviderCatalogStatus() {
      if (this.isProviderCatalogMode && !this.params.sync_status) {
        this.$set(this.params, 'sync_status', 'all');
      }

      if (this.isProviderCatalogMode && !this.params.exception_status) {
        this.$set(this.params, 'exception_status', 'all');
        return;
      }

      if (!this.isProviderCatalogMode && this.params.status === 'all') {
        this.$set(this.params, 'status', null);
      }

      if (!this.isProviderCatalogMode) {
        this.$set(this.params, 'sync_status', 'all');
      }
    },
    setProviderExceptionStatus() {
      if (this.isProviderCatalogMode) {
        this.$set(this.params, 'exception_status', this.params.exception_status || 'all');
        return;
      }

      if (this.showExceptionFilter) {
        this.$set(this.params, 'exception_status', this.params.exception_status || 'all');
        return;
      }

      this.$delete(this.params, 'exception_status');
    },
    changeExceptionStatus(status) {
      this.params.exception_status = status;
      this.params.page = 1;
      this.clearSelectedRows();
      this._loadList();
    },
    sortBy(fieldName) {
      if (this.sortByField !== fieldName) {
        this.reverseSort = false;
      }
      this.params.sort_by = fieldName;
      this.params.sort_direction = !this.reverseSort ? 'asc' : 'desc';
      this.clearSelectedRows();
      this._loadList(this.params)
      this.sortByField = fieldName;

      this.reverseSort = !this.reverseSort;
    },
    changePerPage(perPage) {
      this.params.page = 1;
      this.params.perPage = perPage;
      this.clearSelectedRows();
      this._loadList();
    },
    pageChanged(pageNb) {
      this.params.page = pageNb;
      this.clearSelectedRows();
      this._loadList();
    },
    search() {
      if (this.searchString.length >= 3) {
        this.params.search = this.searchString;
        this.params.page = 1;
        this.clearSelectedRows();
        this._loadList();
      } else if (this.searchString.length === 0) {
        this.params.search = null;
        this.params.page = 1;
        this.clearSelectedRows();
        this._loadList();
      }
    },
    moment(date, format) {
      return moment(date).format(format);
    },
    openForm(action, index = null) {
      this.formAction = action;
      if (action === 'update') {
        this.itemIndex = index;
        this.itemId = this.getBenefitFormId(this.benefits.data[index]);
        if (!this.itemId) {
          this.formAction = '';
          this.itemIndex = null;
          return;
        }
        this.showForm = true;
      }

      if (action === 'create') {
        this.itemId = null;
        this.showForm = true;
      }
    },
    clearForm(formModified = false) {
      this.formAction = '';
      this.showForm = false;
      this.detailIndex = null;
      this.itemId = null;
      if (formModified) {
        this.resetFilters();
        this._loadList()
      }
    },
    resetFilters() {
      this.params = {
        legislated_type: null,
        sub_type: null,
        fiscal_treatment: null,
        type: null,
        status: null,
        partner: null,
        page: 1,
        perPage: 20,
        sort_by: null,
        sort_direction: null,
        location_availability: 0,
        provider_id: this.activeProviderId,
        nav_tree_mapping_status: 'all',
        sync_status: 'all',
      };
      if (this.showExceptionFilter) {
        this.$set(this.params, 'exception_status', 'all');
      }
      if (this.isProviderCatalogMode) {
        this.$set(this.params, 'sync_status', 'all');
        this.$set(this.params, 'exception_status', 'all');
      }
      this.clearSelectedRows();
    },
    exportBenefits() {
       this.isDownloading = true;
      httpFlexbenService.exports.benefits({
        lang: this.locale
      })
        .then(function (response) {
          utils.generateDownloadFromReponse(response);
          this.isDownloading = false;
        }.bind(this))
        .catch(function (error) {
          console.error('Eroare la export:', error);
          this.isDownloading = false;
        }.bind(this));
    },

    exportDiscountVouchers() {
      this.loading = true;
      httpFlexbenService.exports.discountVouchers()
          .then(function (response) {
            utils.generateDownloadFromReponse(response);
            this.loading = false;
          }.bind(this))
          .catch(function (error) {
            console.error('Eroare la export:', error);
            this.loading = false;
          }.bind(this));

    },
    getProviderFromBenefit(item) {
      if (item.provider) {
        return item.provider;
      }

      if (item.provider_id) {
        return {
          id: item.provider_id,
          name: item.provider_name,
          code: item.provider_code,
        };
      }

      return null;
    },
    normalizeProviderValue(value) {
      return (value || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
    },
    isExceptionProvider(provider) {
      const code = this.normalizeProviderValue(provider.code);
      const name = this.normalizeProviderValue(provider.name || provider.label);

      return ['vd', 'voucherdepot', 'briliap', 'briliam'].includes(code)
        || ['vd', 'voucherdepot', 'briliap', 'briliam'].includes(name);
    },
    isProviderCatalogProvider(provider) {
      const identifiers = [
        provider.code,
        provider.slug,
        provider.name,
        provider.label,
      ].map(this.normalizeProviderValue);

      return identifiers.some(identifier => ['vd', 'voucherdepot', 'briliap', 'briliam'].includes(identifier));
    },
    canAddInProviderException(item) {
      // Catalog: exception actions for synced products, or Remove for Excluded (then Sync).
      if (this.isProviderCatalogMode) {
        const canManageException = this.isSyncedProviderProduct(item)
          || item.sync_status === 'excluded'
          || item.is_in_exception === true;

        if (!canManageException) {
          return false;
        }
      }

      if (!this.activeProvider || !this.isExceptionProvider(this.activeProvider)) {
        return false;
      }

      const provider = this.getProviderFromBenefit(item);

      if (!provider) {
        return false;
      }

      if (provider.id && provider.id === this.activeProviderId) {
        return true;
      }

      return this.isExceptionProvider(provider);
    },
    isBenefitSelected(benefitId) {
      return this.selectedBenefitIds.includes(benefitId);
    },
    toggleBenefitSelection(item) {
      const selectedIndex = this.selectedBenefits.findIndex(benefit => benefit.id === item.id);

      if (selectedIndex !== -1) {
        this.selectedBenefits.splice(selectedIndex, 1);
        return;
      }

      this.selectedBenefits.push(item);
    },
    clearSelectedBenefits() {
      this.selectedBenefits = [];
    },
    clearSelectedProviderProducts() {
      this.selectedProviderProducts = [];
    },
    clearSelectedRows() {
      this.clearSelectedBenefits();
      this.clearSelectedProviderProducts();
    },
    getRowKey(item, index) {
      return item.id || item.benefit_id || item.external_id || index;
    },
    getBenefitRowId(item) {
      return item.id || item.benefit_id || '-';
    },
    getBenefitFormId(item) {
      return item ? (item.id || item.benefit_id || null) : null;
    },
    isSyncedProviderProduct(item) {
      return !this.isProviderCatalogMode || item.is_synced === true || item.sync_status === 'synced';
    },
    canShowSelectionCheckbox(item) {
      if (this.isProviderCatalogMode) {
        return true;
      }

      return this.canAddInProviderException(item);
    },
    isRowSelected(item) {
      if (this.isProviderCatalogMode) {
        return this.isProviderProductSelected(item);
      }

      return this.isBenefitSelected(item.id);
    },
    toggleRowSelection(item) {
      if (this.isProviderCatalogMode) {
        this.toggleProviderProductSelection(item);
        return;
      }

      this.toggleBenefitSelection(item);
    },
    getBenefitImage(item) {
      return item.image || item.image_url || this.globalVariables;
    },
    getLegislatedTypeLabel(item) {
      if (typeof item.is_legislated === 'undefined' || item.is_legislated === null) {
        return '-';
      }

      return this.$t(item.is_legislated ? "flexben.benefit.legislated_types.1" : "flexben.benefit.legislated_types.0");
    },
    getProviderSyncStatusLabel(item) {
      const labels = {
        synced: 'Synced',
        not_synced: 'Not synced',
        excluded: 'Excluded',
      };

      return labels[item.sync_status] || item.sync_status || '-';
    },
    getProviderSyncStatusClass(item) {
      const classes = {
        synced: 'badge-success',
        not_synced: 'badge-warning',
        excluded: 'badge-secondary',
      };

      return classes[item.sync_status] || 'badge-secondary';
    },
    getBenefitStatusValue(item) {
      const statusNewMap = {
        1: 'ACTIVE',
        2: 'DRAFT',
        3: 'INACTIVE',
        4: 'DELETED',
      };
      const rawStatus = item.status || item.benefit_status || null;

      if (typeof rawStatus === 'string' && /^(ACTIVE|DRAFT|INACTIVE|DELETED)$/i.test(rawStatus)) {
        return rawStatus.toUpperCase();
      }

      if (item.status_new != null && statusNewMap[item.status_new]) {
        return statusNewMap[item.status_new];
      }

      if (rawStatus != null && statusNewMap[Number(rawStatus)]) {
        return statusNewMap[Number(rawStatus)];
      }

      return null;
    },
    getStatusLabel(item) {
      if (this.isProviderCatalogMode && !this.isSyncedProviderProduct(item)) {
        return this.getProviderSyncStatusLabel(item);
      }

      const status = this.getBenefitStatusValue(item);

      if (!status) {
        return '-';
      }

      return this.$t("flexben.general.status_type." + status.toLowerCase());
    },
    getStatusClass(item) {
      if (this.isProviderCatalogMode && !this.isSyncedProviderProduct(item)) {
        return 'sync-status-badge badge ' + this.getProviderSyncStatusClass(item);
      }

      const status = this.getBenefitStatusValue(item);

      return status ? 'benefit-status-' + status.toLowerCase() : '';
    },
    getLocationAvailabilityLabel(item) {
      if (item.location_availability === null || typeof item.location_availability === 'undefined') {
        return '-';
      }

      return this.$t("flexben.benefit.location_availability." + item.location_availability);
    },
    canOpenBenefitForm(item) {
      return Boolean(this.getBenefitFormId(item)) && (!this.isProviderCatalogMode || this.isSyncedProviderProduct(item));
    },
    canSyncProviderProduct(item) {
      return Boolean(item && item.can_sync === true && item.external_id && item.sync_status === 'not_synced');
    },
    canSelectProviderProduct(item) {
      return this.canSyncProviderProduct(item);
    },
    isProviderProductSelected(item) {
      return this.selectedProviderProductIds.includes(item.external_id);
    },
    toggleProviderProductSelection(item) {
      if (this.isProviderCatalogActionRunning || !this.canSelectProviderProduct(item)) {
        return;
      }

      const selectedIndex = this.selectedProviderProducts.findIndex(product => product.external_id === item.external_id);

      if (selectedIndex !== -1) {
        this.selectedProviderProducts.splice(selectedIndex, 1);
        return;
      }

      this.selectedProviderProducts.push(item);
    },
    syncProviderProduct(item) {
      if (this.isProviderCatalogActionRunning || !this.canSyncProviderProduct(item)) {
        return;
      }

      this.syncProviderProducts([item.external_id]);
    },
    syncSelectedProviderProducts() {
      if (this.isProviderCatalogActionRunning) {
        return;
      }

      if (this.selectedProviderProductIds.length === 0) {
        this.notifyProviderCatalog('Select at least one provider product to sync.', 'warning');
        return;
      }

      this.syncProviderProducts(this.selectedProviderProductIds);
    },
    syncProviderProducts(externalIds) {
      if (this.isProviderCatalogActionRunning || !this.currentProviderCatalogCode || !Array.isArray(externalIds) || externalIds.length === 0) {
        return;
      }

      this.providerSyncSubmitting = true;
      this.httpService.syncProviderProducts({
          provider: this.currentProviderCatalogCode,
          external_ids: externalIds,
        })
        .then((response) => {
          this.notifyProviderCatalog(this.getProviderSyncResultMessage(response.data), 'success');
          this.clearSelectedProviderProducts();
          this._loadList();
        })
        .catch((error) => {
          this.notifyProviderCatalog(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
        })
        .finally(() => {
          this.providerSyncSubmitting = false;
        });
    },
    refreshProviderCache() {
      if (this.isProviderCatalogActionRunning || !this.currentProviderCatalogCode) {
        return;
      }

      this.loading = true;
      this.refreshingProviderCache = true;
      this.httpService.refreshProviderProductsCache({
          provider: this.currentProviderCatalogCode,
        })
        .then((response) => {
          const meta = response.data && response.data.meta ? response.data.meta : {};
          const total = typeof meta.total !== 'undefined' ? meta.total : '-';
          const cachedAt = meta.cached_at || '-';

          this.notifyProviderCatalog('Provider cache refreshed. Total cached: ' + total + '. Cached at: ' + cachedAt + '.', 'success');
          this.loading = false;
          this._loadList();
        })
        .catch((error) => {
          this.notifyProviderCatalog(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
          this.loading = false;
        })
        .finally(() => {
          this.refreshingProviderCache = false;
        });
    },
    confirmRunProviderSyncCommand() {
      if (!this.canShowRunProviderSyncCommand || this.isProviderCatalogActionRunning || this.confirmingProviderSyncCommand) {
        return;
      }

      this.confirmingProviderSyncCommand = true;
      const providerLabel = this.currentProviderCatalogCode === 'vd' ? 'VD' : 'Briliap';
      const message = 'This will run the full provider sync command for ' + providerLabel + '. Continue?';

      if (this.$bvModal && this.$bvModal.msgBoxConfirm) {
        this.$bvModal.msgBoxConfirm(message, {
          title: 'Run provider sync',
          okTitle: 'Continue',
          cancelTitle: 'Cancel',
          okVariant: 'danger',
          cancelVariant: 'secondary',
          centered: true,
        }).then((confirmed) => {
          if (confirmed) {
            this.runProviderSyncCommand();
          }
        }).finally(() => {
          this.confirmingProviderSyncCommand = false;
        });
        return;
      }

      if (window.confirm(message)) {
        this.runProviderSyncCommand();
      }

      this.confirmingProviderSyncCommand = false;
    },
    runProviderSyncCommand() {
      if (this.isProviderCatalogActionRunning || !this.currentProviderCatalogCode) {
        return;
      }

      this.loading = true;
      this.runningProviderSyncCommand = true;
      this.httpService.runProviderSyncCommand({
          provider: this.currentProviderCatalogCode,
        })
        .then((response) => {
          const data = response.data || {};
          this.notifyProviderCatalog(
            data.message || 'Provider sync command finished successfully.',
            'success',
            'Provider sync command'
          );
          this.loading = false;
          this._loadList();
        })
        .catch((error) => {
          this.notifyProviderCatalog(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
          this.loading = false;
        })
        .finally(() => {
          this.runningProviderSyncCommand = false;
        });
    },
    getProviderSyncResultMessage(data) {
      const results = data && Array.isArray(data.results) ? data.results : [];

      if (results.length === 0) {
        return data && data.success ? 'Provider products sync completed.' : 'Provider products sync request completed.';
      }

      const synced = results.filter(result => result.status === 'synced').length;
      const skipped = results.length - synced;

      return 'Synced: ' + synced + ', skipped: ' + skipped + '.';
    },
    notifyProviderCatalog(message, variant = 'info', title = 'Provider catalog') {
      this.notifyException(message, variant, title);
    },
    getBrandLabel(item) {
      if (item.brand && item.brand.id) {
        return '#' + item.brand.id + ' - ' + item.brand.name;
      }

      if (item.brand_name) {
        return item.brand_name;
      }

      return '-';
    },
    getBenefitProductExternalId(item) {
      return item.product_external_id || item.external_id || null;
    },
    buildExceptionProductPayload(item) {
      const provider = this.getProviderFromBenefit(item) || this.activeProvider || {};

      return {
        provider_id: provider.id || item.provider_id || this.activeProviderId,
        product_external_id: this.getBenefitProductExternalId(item),
        product_name: this.getBenefitName(item),
        benefit_id: item.id || item.benefit_id,
        reason: 'Added from benefits admin',
      };
    },
    buildBulkAddProductPayload(item) {
      return {
        product_external_id: this.getBenefitProductExternalId(item),
        product_name: this.getBenefitName(item),
        benefit_id: item.id || item.benefit_id,
        reason: 'Added from benefits admin',
      };
    },
    buildRemoveExceptionPayload(item) {
      return {
        provider_id: item.provider_id || this.activeProviderId,
        product_external_id: this.getBenefitProductExternalId(item),
      };
    },
    buildBulkRemoveProductPayload(item) {
      return {
        product_external_id: this.getBenefitProductExternalId(item),
      };
    },
    getBenefitName(item) {
      if (typeof item.name === 'object' && item.name !== null) {
        return item.name[this.locale] || item.name.ro || item.name.en || '';
      }

      return item.name || '-';
    },
    isMappedInNavTree(item) {
      return item.is_mapped_in_nav_tree === true && this.getNavTreeMappingLabel(item) !== 'Nemapat';
    },
    getNavTreeMappingLabel(item) {
      if (item.is_mapped_in_nav_tree === true && item.nav_tree_mapping_label) {
        return item.nav_tree_mapping_label;
      }

      return 'Nemapat';
    },
    getGroupedNavTreeMappings(item) {
      if (!Array.isArray(item.nav_tree_mappings) || item.nav_tree_mappings.length === 0) {
        return [];
      }

      const groups = [];
      const groupIndexes = {};

      item.nav_tree_mappings.forEach((mapping) => {
        const categoryId = mapping.category_id || null;
        const categoryName = mapping.category_name || (categoryId ? 'Unknown category' : null);

        if (!categoryName) {
          return;
        }

        const groupKey = categoryId ? 'id-' + categoryId : 'name-' + categoryName;

        if (typeof groupIndexes[groupKey] === 'undefined') {
          groupIndexes[groupKey] = groups.length;
          groups.push({
            key: groupKey,
            category_id: categoryId,
            category_name: categoryName,
            direct_category_mapping: false,
            subcategories: [],
            subcategoryIndexes: {},
          });
        }

        const group = groups[groupIndexes[groupKey]];

        if (mapping.subcategory_id && mapping.subcategory_name) {
          const subcategoryKey = 'id-' + mapping.subcategory_id;

          if (typeof group.subcategoryIndexes[subcategoryKey] === 'undefined') {
            group.subcategoryIndexes[subcategoryKey] = true;
            group.subcategories.push({
              key: subcategoryKey,
              id: mapping.subcategory_id,
              name: mapping.subcategory_name,
            });
          }

          return;
        }

        group.direct_category_mapping = true;
      });

      return groups.map((group) => {
        delete group.subcategoryIndexes;
        return group;
      });
    },
    isValidExceptionPayload(payload) {
      return Boolean(payload.provider_id && payload.product_external_id && payload.product_name);
    },
    isValidBulkAddProductPayload(payload) {
      return Boolean(payload.product_external_id && payload.product_name);
    },
    isValidRemoveExceptionPayload(payload) {
      return Boolean(payload.provider_id && payload.product_external_id);
    },
    isValidBulkRemoveProductPayload(payload) {
      return Boolean(payload.product_external_id);
    },
    getErrorMessage(error) {
      if (error && (error.code === 'ECONNABORTED' || (error.message && error.message.includes('timeout')))) {
        return 'The provider catalog request timed out. Please try again.';
      }

      return (error.response && error.response.data && (error.response.data.message || error.response.data.error))
     || this.$t('flexben.general.error_occurred');
    },
    notifyException(message, variant = 'info', title = 'Provider exceptions') {
      if (this.$bvToast) {
        this.$bvToast.toast(message, {
          title: title,
          autoHideDelay: 5000,
          toaster: 'b-toaster-bottom-center',
          variant: variant,
          solid: true,
        });
        return;
      }

      console.warn(message);
    },
    getBulkResponseSummary(data) {
      const responseData = data && data.summary ? data.summary : data || {};

      return {
        created: responseData.created || 0,
        updated: responseData.updated || 0,
        skipped: responseData.skipped || 0,
        errors: responseData.errors || [],
      };
    },
    getBulkRemoveResponseSummary(data) {
      const responseData = data && data.summary ? data.summary : data || {};

      return {
        removed: responseData.removed || 0,
        skipped: responseData.skipped || 0,
        errors: responseData.errors || [],
      };
    },
    getBulkSummaryMessage(summary, skippedBeforeRequest) {
      const errorCount = Array.isArray(summary.errors) ? summary.errors.length : summary.errors;

      return 'Created: ' + summary.created
        + ', updated: ' + summary.updated
        + ', skipped: ' + (summary.skipped + skippedBeforeRequest)
        + ', errors: ' + (errorCount || 0);
    },
    getBulkRemoveSummaryMessage(summary, skippedBeforeRequest) {
      const errorCount = Array.isArray(summary.errors) ? summary.errors.length : summary.errors;

      return 'Removed: ' + summary.removed
        + ', skipped: ' + (summary.skipped + skippedBeforeRequest)
        + ', errors: ' + (errorCount || 0);
    },
    removeSelectedBenefit(benefitId) {
      const selectedIndex = this.selectedBenefits.findIndex(benefit => benefit.id === benefitId);

      if (selectedIndex !== -1) {
        this.selectedBenefits.splice(selectedIndex, 1);
      }
    },
    toggleBenefitException(item) {
      if (item.is_in_exception) {
        this.removeBenefitFromException(item);
        return;
      }

      this.addBenefitInException(item);
    },
    addBenefitInException(item) {
      const payload = this.buildExceptionProductPayload(item);

      if (!this.isValidExceptionPayload(payload)) {
        this.notifyException('Cannot add benefit in exception. Missing provider, product external id or product name.', 'warning');
        return;
      }

      this.exceptionSubmitting = true;
      this.httpService.addProviderExcludedProduct(payload)
        .then((response) => {
          this.$set(item, 'is_in_exception', true);
          this.$set(item, 'provider_excluded_product', response.data.item || response.data.data || response.data || null);
          this.removeSelectedBenefit(item.id);
          this.notifyException('Benefit added in provider exceptions.', 'success');
          if (this.params.exception_status === 'not_in_exception') {
            this._loadList();
          }
        })
        .catch((error) => {
          this.notifyException(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
        })
        .finally(() => {
          this.exceptionSubmitting = false;
        });
    },
    removeBenefitFromException(item) {
      const payload = this.buildRemoveExceptionPayload(item);

      if (!this.isValidRemoveExceptionPayload(payload)) {
        this.notifyException('Cannot remove benefit from exception. Missing provider or product external id.', 'warning');
        return;
      }

      this.exceptionSubmitting = true;
      this.httpService.removeProviderExcludedProduct(payload)
        .then(() => {
          this.$set(item, 'is_in_exception', false);
          this.$set(item, 'provider_excluded_product', null);
          this.$set(item, 'provider_excluded_product_id', null);

          // Excluded → Not synced so Sync appears without waiting for list reload.
          if (item.sync_status === 'excluded') {
            this.$set(item, 'sync_status', 'not_synced');
            this.$set(item, 'can_sync', true);
            this.$set(item, 'is_synced', false);
          }

          this.removeSelectedBenefit(item.id);
          this.notifyException('Benefit removed from provider exceptions.', 'success');
          if (this.params.exception_status === 'in_exception') {
            this._loadList();
          }
        })
        .catch((error) => {
          this.notifyException(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
        })
        .finally(() => {
          this.exceptionSubmitting = false;
        });
    },
    addSelectedInException() {
      const products = [];
      let skippedBeforeRequest = 0;

      this.selectedNotInExceptionBenefits.forEach(item => {
        const productPayload = this.buildBulkAddProductPayload(item);

        if (this.isValidBulkAddProductPayload(productPayload)) {
          products.push(productPayload);
        } else {
          skippedBeforeRequest++;
        }
      });

      if (products.length === 0) {
        this.notifyException('No selected benefits have a complete provider exception payload.', 'warning');
        return;
      }

      const payload = {
        provider_id: this.activeProviderId,
        products: products,
      };

      this.exceptionSubmitting = true;
      this.httpService.bulkAddProviderExcludedProducts(payload)
        .then((response) => {
          const summary = this.getBulkResponseSummary(response.data);
          const hasErrors = Array.isArray(summary.errors) ? summary.errors.length > 0 : Boolean(summary.errors);
          const variant = hasErrors || skippedBeforeRequest > 0 ? 'warning' : 'success';

          this.notifyException(this.getBulkSummaryMessage(summary, skippedBeforeRequest), variant);
          this.clearSelectedBenefits();
          this._loadList();
        })
        .catch((error) => {
          this.notifyException(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
        })
        .finally(() => {
          this.exceptionSubmitting = false;
        });
    },
    removeSelectedFromException() {
      const products = [];
      let skippedBeforeRequest = 0;

      this.selectedInExceptionBenefits.forEach(item => {
        const productPayload = this.buildBulkRemoveProductPayload(item);

        if (this.isValidBulkRemoveProductPayload(productPayload)) {
          products.push(productPayload);
        } else {
          skippedBeforeRequest++;
        }
      });

      if (products.length === 0) {
        this.notifyException('No selected benefits have a complete remove exception payload.', 'warning');
        return;
      }

      const payload = {
        provider_id: this.activeProviderId,
        products: products,
      };

      this.exceptionSubmitting = true;
      this.httpService.bulkRemoveProviderExcludedProducts(payload)
        .then((response) => {
          const summary = this.getBulkRemoveResponseSummary(response.data);
          const hasErrors = Array.isArray(summary.errors) ? summary.errors.length > 0 : Boolean(summary.errors);
          const variant = hasErrors || skippedBeforeRequest > 0 ? 'warning' : 'success';

          this.notifyException(this.getBulkRemoveSummaryMessage(summary, skippedBeforeRequest), variant);
          this.clearSelectedBenefits();
          this._loadList();
        })
        .catch((error) => {
          this.notifyException(this.getErrorMessage(error), 'danger', this.$t('flexben.general.error'));
        })
        .finally(() => {
          this.exceptionSubmitting = false;
        });
    }
  },
};
</script>

<style src="@/assets/styles/beneficiary.css"></style>
<style src="@/assets/styles/flexben.css"></style>
<style scoped>
.provider-tabs .btn-request-type {
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: 0.25rem;
  color: #585858;
  cursor: pointer;
  font-size: 14px;
  height: 100%;
  line-height: 1.1;
  max-width: 350px;
  opacity: 0.9;
  padding: 1.1rem 0.5rem;
  text-align: center;
  transition: background-color 300ms ease;
  width: 100%;
}

.provider-tabs .btn-request-type-active,
.provider-tabs .btn-request-type:hover {
  background: var(--color-f49400);
  border-color: var(--color-f49400);
  opacity: 1;
}

.app-category-cell {
  max-width: 360px;
  min-width: 220px;
}

.app-category-label {
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.app-category-tree {
  display: grid;
  gap: 6px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 100%;
}

.app-category-group {
  background: #f8f9fb;
  border: 1px solid #e7e9ee;
  border-radius: 4px;
  min-width: 0;
  padding: 5px 7px;
}

.app-category-name {
  color: #3d3d3d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.app-subcategory-list {
  color: #626262;
  font-size: 11px;
  line-height: 1.3;
  list-style-position: outside;
  margin: 3px 0 0 14px;
  padding: 0;
}

.app-subcategory-list li {
  margin: 1px 0;
  overflow-wrap: anywhere;
}

.provider-cache-meta {
  color: #585858;
  font-size: 13px;
}

.sync-status-badge {
  font-size: 12px;
  padding: 6px 8px;
}

@media screen and (max-width: 768px) {
  .provider-tabs .btn-request-type {
    max-width: 100%;
    padding: 0.6rem 0.3rem;
  }

  .app-category-tree {
    grid-template-columns: 1fr;
  }
}
</style>
